import { Controller } from '@hotwired/stimulus';
import { Toast } from 'bootstrap/dist/js/bootstrap.bundle.min.js';

export default class extends Controller {
  static targets = ['toast'];

  connect() {
    this.toasts = [];
    this.toastTargets.forEach(el => {
      // Permanent elements can disconnect during frame replacement. Keep their original deadline.
      const expiresAt = Number(el.dataset.expiresAt) || Date.now() + 5000;
      el.dataset.expiresAt = expiresAt;
      const delay = expiresAt - Date.now();
      if (delay <= 0) {
        el.remove();
        return;
      }
      // Bootstrap does not cancel animation callbacks when Turbo removes a toast and we dispose it.
      const toast = new Toast(el, { animation: false, autohide: true, delay });
      toast.show();
      this.toasts.push(toast);
    });
  }

  dismiss(event) {
    event.target.remove();
  }

  disconnect() {
    this.toasts.forEach(t => t.dispose());
    this.toasts = [];
  }
}
